import { render, staticRenderFns } from "./RestaurantsManager.vue?vue&type=template&id=aff838fe&lang=pug"
import script from "./RestaurantsManager.vue?vue&type=script&lang=js"
export * from "./RestaurantsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports